import { createContext, useContext, type ReactNode } from 'react';
import { getTheme, type ThemeStyles } from '../utils/theme';
import type { ThemeColor } from '../utils/storage';

interface AppTheme {
  theme: ThemeStyles;
  themeColor: ThemeColor;
  isDark: boolean;
}

const ThemeContext = createContext<AppTheme>({ theme: getTheme('emerald', true), themeColor: 'emerald', isDark: true });

/** Zet het kleurthema en licht/donker klaar voor alle componenten, zodat het geen prop hoeft te zijn. */
export function AppThemeProvider({ themeColor, isDark, children }: { themeColor: ThemeColor; isDark: boolean; children: ReactNode }) {
  return <ThemeContext.Provider value={{ theme: getTheme(themeColor, isDark), themeColor, isDark }}>{children}</ThemeContext.Provider>;
}

export const useAppTheme = () => useContext(ThemeContext);
